import { useAction, useAtom } from "@reatom/npm-react";
import { Helmet } from "react-helmet";
import { PageLayout } from "src/components";
import { appConfig } from "src/config";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { useTranslate } from "src/i18n/hooks";
import { filtersModalAtom } from "src/store/atoms";

import { ProductData } from "./components/ProductData";
import css from "./ProductPage.module.scss";
import { cardOrTable } from "./store/atoms";
import { ProductSearch } from "./widgets";

export const ProductPage = () => {
  const { isMobile, isDesktop } = useGravityDevice();
  const [isCards, setIsCards] = useAtom(cardOrTable);
  const toggleFiltersModal = useAction(filtersModalAtom.toggle);
  const { t } = useTranslate();

  return (
    <>
      <Helmet>
        <title>
          {t("product_page.title", "{brand} · Консоль · Товары", {
            brand: appConfig.displayName,
          })}
        </title>
      </Helmet>
      <PageLayout>
        <div className={css.wrapper}>
          <ProductSearch
            isMobile={isMobile}
            isDesktop={isDesktop}
            isCards={isCards}
            setIsCards={setIsCards}
            setFiltersModalIsOpen={toggleFiltersModal}
          />
          <ProductData isTable={!isMobile && !isCards} />
        </div>
      </PageLayout>
    </>
  );
};
